<template>
  <div>
   <HeaderBreadcrumbs
			:items="[{
					label: 'Revenue Shares',
					to:''
				},
			]"
			title="All Revenue Shares"
		/>
 <div class="flex justify-between items-center py-3 px-4 bg-white">
   <div class="relative">
                    <svg  class="w-6 h-6 text-gray-500 dark:text-white absolute top-1.5 left-3"
                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                        viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
                            d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
                    </svg>
                    <input class="bg-white rounded-lg py-2 px-11 border w-96"
                        placeholder='Search Revenue Share Name' v-model="message" @input="debounceSearch" />
                    <button v-if="message"
                        class="absolute top-1/2 right-5 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                        @click="actionReset" title="Clear search">
                        ✕
                    </button>
                </div>
                <div class="relative flex justify-end">
                  <button
            class=" mr-3 bg-blue-700 border text-white focus:outline-none font-medium rounded-lg text-sm px-2 py-2.5 text-center"
            type="button">
            <router-link
                :to="{ path: '/revenueshare/create' }"
                class="text-white hover:no-underline"
              >
               <i class="fa fa-plus"></i> Add New
              </router-link>
          </button>
           <t-dropdown>
            <div slot="trigger" slot-scope="{ mousedownHandler, focusHandler, blurHandler, keydownHandler }"
              class="flex">
              <button
                class="flex relative items-center justify-center h-10 px-3 py-2.5 text-gray-500 bg-white border border-gray-400 rounded-lg"
                @mousedown="mousedownHandler" @focus="focusHandler" @blur="blurHandler" @keydown="keydownHandler">
                <svg class="w-4 h-4 mr-1 text-gray-600 dark:text-white" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M5.05 3C3.291 3 2.352 5.024 3.51 6.317l5.422 6.059v4.874c0 .472.227.917.613 1.2l3.069 2.25c1.01.742 2.454.036 2.454-1.2v-7.124l5.422-6.059C21.647 5.024 20.708 3 18.95 3H5.05Z" />
                </svg>
                Filter
                <svg class="w-5 h-5 ml-1 text-gray-600 fill-current" viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <polygon
                    points="9.29289322 12.9497475 10 13.6568542 15.6568542 8 14.2426407 6.58578644 10 10.8284271 5.75735931 6.58578644 4.34314575 8" />
                </svg>
                  <div v-if="dataBadge"
                  class="rounded-full w-5 h-5 bg-red-600 absolute -top-2 -right-2 text-white text-xs flex justify-center items-center">
                  {{ dataBadge }}
                  </div>
              </button>
            </div>
            <div class="w-custom bg-white absolute -right-2 pt-2 pb-3 border rounded-lg"
              slot-scope="{ hide, blurHandler }">
              <div
                class="block w-full px-4 py-2 text-sm text-gray-500 transition duration-150 ease-in-out focus:outline-none focus:bg-gray-100"
                role="menuitem">
                <div class="flex justify-between mb-3 mt-2">
                  <div>Filter</div>
                  <div @click="hide">
                    <svg class="w-4 h-4 text-gray-800 dark:text-white cursor-pointer" aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M6 18 17.94 6M18 18 6.06 6" />
                    </svg>
                  </div>
                </div>
                <div class="grid gap-4 grid-cols-1">
                 
                  <div>
                    <label class="text-gray-600 font-semibold mb-3">Status</label>
                      <StatusFilter
                      v-model="status"
                      :options="statusOptions"
                      :defaultText="`Select Status`"
                       />
                    </div>
                </div>
                <div class="mt-3">
                  <button class="border bg-blue-700 px-4 py-2 text-white rounded-lg" @click="onStatusChange()"
                    @blur="blurHandler">
                    Filter
                  </button>
                  <button class="border bg-white text-gray-500 px-4 py-2 rounded-lg ml-2" @click="actionReset()"
                    @blur="blurHandler">Reset</button>
                </div>
              </div>
            </div>
          </t-dropdown>
          </div>
 </div>
  <div class="flex-col justify-between items-center bg-white rounded-lg h-custom-revenue-shared">
 <Table
    :headers="headers"
      :data="RevenueShare"
      :row-key="['name', 'description', 'fixed_amount', 'percentage_amount', 'is_active', 'created']"
      :current-page="currentPage"
      :isLoading="isLoading"
      :per-page="perPage">
      <template #fixed_amount="{ row }">
            {{ parseFloat(row.default_fixed_amount).toFixed(1) }}
        </template>
        <template #percentage_amount="{ row }">
            {{ toPercent(row.default_percentage_amount) }}%
        </template>
        
       <template #header-join-date="{ column }">
          <div class="flex items-center gap-1">
            {{ column.label }}
            <button @click="sortBy(column.key)" class="text-xs text-gray-500">
              <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg>
                </span>
            </button>
          </div>
        </template>
         <template #created="{ value }">
          <span>{{ formatDate(value).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDate(value).time }}</span>
        </template>
         <template #is_active={value}>
         <div style="" class="text-center py-1 px-1.5 rounded-lg w-auto" :class="{ 'bg-green-100': value === true, 'bg-gray-100': value === false }">
            <span v-if="value">
              Active
            </span>
            <span v-else>
              Inactive
            </span>
          </div>

        </template>
         <template #actions="{ row }">
          <router-link :to="{ path: '/revenueshare/edit/' + row.id }"
            class="link text-gray-600 align-middle items-center flex justify-center">
            <svg class="w-6 h-6 text-gray-600 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
              <path fill-rule="evenodd"
                d="M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z"
                clip-rule="evenodd" />
              <path fill-rule="evenodd"
                d="M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z"
                clip-rule="evenodd" />
            </svg>
          </router-link>
          </template>
  </Table>
   <div v-if="!isLoading && RevenueShare.length  " class="flex bg-white justify-between pl-3 pr-3 pt-4 mb-0 border-t rounded-lg border-gray-100 mt-1">
          <div class="font-semibold">
            <span class="text-gray-500 font-normal">Showing </span> {{ currentPage }}-{{ perPage }} <span
              class="text-gray-500 font-normal">of</span> {{ parseInt(totalRows) }}
          </div>
          <div class="mb-2">
            <t-pagination :total-items="Number(totalRows)" :per-page="perPage" v-model="currentPage"
              />
          </div>
        </div>
        </div>
  </div>

</template>
<script>
import { mapActions, mapState } from 'vuex';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs.vue';
import Table from '../../components/form/table.vue';
import StatusFilter from '@/components/form/StatusFilterComponent.vue'
import moment from 'moment';
export default {
  name: 'RevenueShare',
  components: {
    HeaderBreadcrumbs,
    Table,
    StatusFilter
  },
  data() {
    return {
      currentPage: 1,
      perPage: 15,
      filter: {},
      sorts:[],
      isLoadingSearch: false,
      items_search: [],
      message: '',
      typing: null,
      fields: [
        { key: 'No', label: 'No.' },
        { key: 'name', label: 'Name' },
        { key: 'description', label: 'Description' },
        { key: 'fixed_amount', label: 'Fixed Amount' },
        { key: 'percentage_amount', label: 'Percentage Amount' },
        { key: 'is_active', label: 'Status' },
        { key: 'created', label: 'Created' },
        { key: 'action', label: '' },
      ],
      headers: [
        { label: 'No', key: 'no' },
        { label: 'Revenue share name', key: '' },
        { label: 'description', key: '' },
        { label: 'fixed amount', key: 'fixed_amount' },
        { label: 'percentage amount', key: 'percentage_amount'},
        { label: 'Status', key: 'is_active' },
        { label: 'join Date', key: 'created',sortable: true, slotHeader: 'header-join-date' },
       
      ],
      status: '',
      dataBadge:null,
      statusOptions: [
        { value: null, text: 'All Status' },
        { value: 'true', text: 'Active' },
        { value: 'false', text: 'Inactive' },
      ],
    };
  },
  watch: {
    currentPage: function() {
      this.getRevenueShares();
    },
    $route: {
      immediate: true,
      handler(to) {
        document.title =
          to.meta.title ||
          'Revenue Share | Content Management System Ebooks Gramedia.com';
      },
    },
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.revenueshares.isLoading,
      isError: (state) => state.revenueshares.isError,
      totalRows: (state) => state.revenueshares.totalRows,
      RevenueShare: (state) => state.revenueshares.items,
    }),
  },
  mounted() {
    this.getRevenueShares();
  },
  methods: {
    ...mapActions('revenueshares', ['fetchAllRevenueShares']),

    getRevenueShares() {
      let payload = {
        name: this.message,
        status: this.status,
        page: this.currentPage,
        limit: this.perPage,
      };
      this.fetchAllRevenueShares(payload);
    },
  formatDate(tgl) {
    return {
      date: moment(tgl).format('DD MMMM YYYY'),
      time: moment(tgl).format('HH:mm:ss'),
    };
  },
  sortBy(column) {
    let existingIndex = this.sorts.findIndex(s => s.column === column);

    if (existingIndex >= 0) {
      this.sorts[existingIndex].order =
      this.sorts[existingIndex].order === "asc" ? "desc" : "asc";

      const [item] = this.sorts.splice(existingIndex, 1);
      this.sorts.unshift(item);
    } else {
      this.sorts.unshift({ column, order: "asc" });
    }

    let sortString = this.sorts
      .map(s => `${s.column}_${s.order}`)
      .join(',');
          this.fetchAllRevenueShares({
          name: this.message,
          page: this.currentPage,
          limit: this.perPage,
          status: this.status,
          sort:sortString
        });
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        //this.typing = null;
        this.message = event.target.value;
        this.fetchAllRevenueShares({
          name: this.message,
          page: this.currentPage = 1,
          limit: this.perPage,
          status: this.status,
        });
      }, 600);
    },

    formatNumber(value) {
      if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
      return '0';
    },

    toPercent(num) {
      return (parseFloat(num) * 100).toFixed(1);
    },
actionReset() {
     this.dataBadge = null
      this.message = ''
      this.status = ''
       this.getRevenueShares();
    },
    onStatusChange() {
      let payload = {
        name: this.message,
        status: this.status,
        page: this.currentPage = 1,
        limit: this.perPage,
      };
      this.fetchAllRevenueShares(payload);
      this.filterBadge()
    },
     filterBadge() {
      let badgeCount = 0;
      badgeCount += [this.status].filter(status => status != null).length;

      this.dataBadge = badgeCount > 0 ? badgeCount : null;
    },
  },
};
</script>
<style>
.h-custom-revenue-shared {
  min-height: 600px;
}
.w-custom {
  width: 540px;
}
</style>